"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.launch = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var launch = function launch(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'launch-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M16 3.34521C16.4142 3.34521 16.75 3.681 16.75 4.09521V8.09521C16.75 8.50943 16.4142 8.84521 16 8.84521C15.5858 8.84521 15.25 8.50943 15.25 8.09521V5.90587L9.53033 11.6255C9.23744 11.9184 8.76256 11.9184 8.46967 11.6255C8.17678 11.3327 8.17678 10.8578 8.46967 10.5649L14.1893 4.84521L12 4.84521C11.5858 4.84521 11.25 4.50943 11.25 4.09521C11.25 3.681 11.5858 3.34521 12 3.34521H16Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.25 6.09521C3.25 5.681 3.58579 5.34521 4 5.34521H9C9.41421 5.34521 9.75 5.681 9.75 6.09521C9.75 6.50943 9.41421 6.84521 9 6.84521H4.75V15.3452H13.25V11.0952C13.25 10.681 13.5858 10.3452 14 10.3452C14.4142 10.3452 14.75 10.681 14.75 11.0952V16.0952C14.75 16.5094 14.4142 16.8452 14 16.8452H4C3.58579 16.8452 3.25 16.5094 3.25 16.0952V6.09521Z',
    fill: '#4B5563'
  }));
};

exports.launch = launch;